import React from 'react'
import classes from './Dulap.module.css'
import { Banner } from '~/components/Banner/Banner'
import { FormattedMessage } from 'react-intl'
import { ProductTypesList } from '~/components/ProductTypesList/ProductTypesList'
import { ProductTypesListNew } from '~/components/ProductTypesList/productTypesListNew'
import { CatalogSection } from '~/components/CatalogSection/CatalogSection'
import { AboutUs } from '~/components/AboutUs/AboutUs'
import ContactBox from '~/components/ContactBox/ContactBox'
import { InfoBar } from '~/components/InfoBar/InfoBar'
import { FAQ } from '~/components/FAQ/FAQ'
import { landingInfoBarContent } from '~/components/InfoBar/LandingInfoBarContent'
import BlogsList from '~/components/Blog/BlogsList'
import { FAQcontentLanding } from '~/components/FAQ/FAQcontentLanding'
import { useScrollAnimation } from '~/hooks/useScrollAnimation'
import animationStyles from '~/styles/animations.module.css'
import ReviewsSection from '~/components/Reviews/ReviewsSection'

export const Dulap: React.FC = () => {
  const { ref: titleRef, isVisible: isTitleVisible } = useScrollAnimation({
    threshold: 0.3,
  })
  const { ref: titleRef2, isVisible: isTitleVisible2 } = useScrollAnimation({
    threshold: 0.3,
  })
  const { ref: catalogTitleRef, isVisible: isCatalogTitleVisible } =
    useScrollAnimation({
      threshold: 0.3,
    })

  return (
    <div>
      <link
        rel="preload"
        as="image"
        href="/cdn/landing/landing-m-1080.webp"
        media="(max-width: 768px)"
        fetchPriority="high"
        imageSrcSet="/cdn/landing/landing-m-480.webp 480w, /cdn/landing/landing-m-768.webp 768w, /cdn/landing/landing-m-1080.webp 1080w"
        imageSizes="100vw"
      />
      <link
        rel="preload"
        as="image"
        href="/cdn/landing/landing-1920.webp"
        media="(min-width: 769px)"
        fetchPriority="high"
        imageSrcSet="/cdn/landing/landing-1280.webp 1280w, /cdn/landing/landing-1920.webp 1920w, /cdn/landing/landing-2560.webp 2560w"
        imageSizes="100vw"
      />
      <Banner
        href={'/cdn/landing/landing-1920.jpg'}
        mobileHref={'/cdn/landing/landing-m-768.jpg'}
        desktopSources={{
          webpSrcSet:
            '/cdn/landing/landing-1280.webp 1280w, /cdn/landing/landing-1920.webp 1920w, /cdn/landing/landing-2560.webp 2560w',
          jpegSrcSet:
            '/cdn/landing/landing-1280.jpg 1280w, /cdn/landing/landing-1920.jpg 1920w, /cdn/landing/landing-2560.jpg 2560w',
          sizes: '100vw',
        }}
        mobileSources={{
          webpSrcSet:
            '/cdn/landing/landing-m-480.webp 480w, /cdn/landing/landing-m-768.webp 768w, /cdn/landing/landing-m-1080.webp 1080w',
          jpegSrcSet:
            '/cdn/landing/landing-m-480.jpg 480w, /cdn/landing/landing-m-768.jpg 768w, /cdn/landing/landing-m-1080.jpg 1080w',
          sizes: '100vw',
        }}
        blurDataURL="data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAAAwBACdASoYABAAPwFqrU8rJiQiMAgBYCAJZQCdMoACs+6/21+rG+RC2gAA/IzVnIykVFi94L1lFFSWRRjZzGWh1e+TO2KrJzB2AzGOky+DW8gcOH+/uSDsuhRPM7YH2ME30Exg7sQAAA=="
        hideRadius={true}
      />
      <section className={classes.infoBar}>
        <InfoBar items={landingInfoBarContent} />
      </section>
      <section className={classes.productTypes}>
        <h2
          ref={titleRef as React.RefObject<HTMLHeadingElement>}
          className={`${classes.productTypesTitle} ${isTitleVisible ? animationStyles.fadeInDown : ''}`}
        >
          <FormattedMessage id="homepage.dulapLanding.title1" />
        </h2>
        <ProductTypesList></ProductTypesList>
      </section>

      <section className={classes.productTypes}>
        <h2
          ref={titleRef2 as React.RefObject<HTMLHeadingElement>}
          className={`${classes.productTypesTitle} ${isTitleVisible2 ? animationStyles.fadeInDown : ''}`}
        >
          <FormattedMessage id="homepage.dulapLanding.title1.2" />
        </h2>
        <ProductTypesListNew></ProductTypesListNew>
      </section>

      <br />

      <section className={classes.readyProducts}>
        <h2
          ref={catalogTitleRef as React.RefObject<HTMLHeadingElement>}
          className={`${classes.readyProductsTitle} ${isCatalogTitleVisible ? animationStyles.fadeInDown : ''}`}
        >
          <FormattedMessage id="homepage.dulapLanding.title2" />
        </h2>
        <CatalogSection />
      </section>

      <br />
      <section className={classes.reviews}>
        <h2 className={classes.galleryTitle}>
          <FormattedMessage id="homepage.dulapLanding.reviewsTitle" />
        </h2>
        <ReviewsSection></ReviewsSection>
      </section>
      <br />
      <br />
      <section className={classes.blog}>
        <h2 className={classes.galleryTitle}>
          <FormattedMessage id="homepage.dulapLanding.title4" />
        </h2>
        <div className={classes.blogList}>
          <BlogsList></BlogsList>
        </div>
      </section>
      <section className={classes.faq}>
        <FAQ content={FAQcontentLanding}></FAQ>
      </section>
      <section className={classes.aboutUs}>
        <AboutUs></AboutUs>
      </section>
      <ContactBox
        title={<FormattedMessage id="contactBox.title" />}
        subtitle={<FormattedMessage id="contactBox.subtitle" />}
        showEmail={true}
        showTextarea={true}
        modalThankYouMessage="contactForm.modal.thankYouMessage"
      ></ContactBox>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  )
}
